<div>
  <ng-container *ngIf="isMobile">
    <div (click)="goToLogin()" class="arrow-left tappable">
      <img src="assets/image/arrow-left.svg" />
    </div>

    <div class="text-login mt-3 text-center">
      <h4 *ngIf="personType == 'pj'">Cadastro pessoa jurídica</h4>
      <h4 *ngIf="personType == 'pf'">Cadastro pessoa física</h4>

      <p *ngIf="personType == 'pj'">
        Cadastre-se gratuitamente para sua empresa enviar e receber dinheiro do
        exterior.
      </p>
      <p *ngIf="personType == 'pf'">
        Cadastre-se gratuitamente para enviar e receber dinheiro do exterior.
      </p>
    </div>
  </ng-container>

  <ng-container *ngIf="!isMobile">
    <div class="desc">
      <div class="mt-4 text-center">
        <img
          *ngIf="personType == 'pj'"
          src="assets/image/merchants/{{ tenant }}/logo-login-blue.svg"
        />
        <img
          *ngIf="personType == 'pf'"
          src="assets/image/merchants/{{ tenant }}/logo-login-blue-pf.svg"
        />
      </div>
      <div class="text-login mt-2 text-center">
        <h1 *ngIf="personType == 'pj'">Cadastro Pessoa Jurídica</h1>
        <h1 *ngIf="personType == 'pf'">Cadastro Pessoa Física</h1>
      </div>
    </div>
  </ng-container>

  <div class="container-register mt-2">
    <form [formGroup]="registerForm">
      <div>
        <mat-form-field *ngIf="registerForm.get('cnpj')" appearance="outline">
          <mat-label>CNPJ</mat-label>
          <input
            matInput
            formControlName="cnpj"
            mask="AA.AAA.AAA/AAAA-00"
            [clearIfNotMatch]="false"
            uppercase
            type="text"
            placeholder="AA.AAA.AAA/AAAA-00"
            autocomplete="off"
            style="text-transform: uppercase"
            required
          />
          <mat-error
            *ngIf="
              registerFormControl.cnpj.touched &&
              registerFormControl.cnpj.errors?.required
            "
          >
            CNPJ obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{
            personType == "pj"
              ? "Nome completo do Responsável Legal"
              : "Nome completo"
          }}</mat-label>
          <input matInput formControlName="firstName" type="text" required />
          <mat-error
            *ngIf="
              registerFormControl.firstName.touched &&
              registerFormControl.firstName.errors?.required
            "
          >
            {{
              personType == "pj"
                ? "Nome completo do Responsável Legal obrigatório"
                : "Nome completo obrigatório"
            }}
          </mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="registerForm.get('cpf')" appearance="outline">
          <mat-label>CPF</mat-label>
          <input
            matInput
            formControlName="cpf"
            mask="000.000.000-00"
            type="text"
            placeholder="000.000.000-00"
            required
          />
          <mat-error
            *ngIf="
              registerFormControl.cpf.touched &&
              registerFormControl.cpf.errors?.required
            "
          >
            CPF obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Celular</mat-label>
          <input
            matInput
            mask="(00) 00000-0000"
            placeholder="(00) 00000-0000"
            type="tel"
            formControlName="phonenumber"
            required
          />
          <mat-error
            *ngIf="
              registerFormControl.phonenumber.touched &&
              registerFormControl.phonenumber.errors?.required
            "
          >
            Celular obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput formControlName="email" type="text" required />
          <mat-error
            *ngIf="
              registerFormControl.email.touched &&
              registerFormControl.email.errors?.required
            "
          >
            E-mail obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="mb-3">
          <mat-label>Senha</mat-label>

          <input
            [type]="hide ? 'password' : 'text'"
            matInput
            required
            formControlName="password"
          />

          <button
            class="eye-color"
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <img
              [src]="
                hide
                  ? 'assets/image/eye-icon-open.svg'
                  : 'assets/image/eye-icon-close.svg'
              "
            />
          </button>

          <mat-error
            class="mb-1"
            *ngIf="
              registerFormControl.password.touched &&
              registerFormControl.password.errors?.minlength
            "
          >
            Digite uma senha de no mínimo oito caracteres
          </mat-error>
          <mat-error
            *ngIf="
              registerFormControl.password.touched &&
              registerFormControl.password.errors?.required
            "
          >
            Senha obrigatória
          </mat-error>
        </mat-form-field>
      </div>
      <section class="checkbox-container mt-2">
        <mat-checkbox
          formControlName="acceptedterms"
          class="margin-check mt-2"
          required
        ></mat-checkbox>
        <span> Confirmo concordar com os </span>
        <a class="tappable" (click)="openTermsModal()">Termos de Uso </a>
        <span>e </span>
        <a class="tappable" (click)="openPrivacyPolicyModal()"
          >Política de Privacidade.</a
        >
        <br />
        <div>
          <mat-checkbox
            formControlName="acceptedoffer"
            class="margin-check mt-2"
          ></mat-checkbox>
          <span> Desejo receber ofertas e informações do Grupo OZ. </span>
        </div>
      </section>
      <div class="mt-3">
        <ng-container *ngIf="personType == 'pj'">
          <button
            class="btn btn-block mt-2"
            type="button"
            [ngClass]="{
              'btn-disabled': registerForm.invalid,
              'btn-dark-blue': !registerForm.invalid
            }"
            (click)="register()"
            [disabled]="registerForm.invalid"
          >
            Cadastrar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </ng-container>

        <ng-container *ngIf="personType == 'pf'">
          <button
            class="btn btn-block mt-2"
            type="button"
            [ngClass]="{
              'btn-disabled': registerForm.invalid,
              'btn-dark-blue-pf': !registerForm.invalid
            }"
            (click)="register()"
            [disabled]="registerForm.invalid"
          >
            Cadastrar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </ng-container>
      </div>
    </form>
    <div class="forgot-pass text-center mt-2">
      <p class="mt-3 mb-3">
        Já tem conta?
        <a (click)="goToLogin()" class="tappable">Faça login.</a>
      </p>
    </div>

    <ng-container *ngIf="isMobile">
      <div (click)="goToLogin()" class="text-center mt-5 lg-bottom">
        <img
          class="logo-oz"
          src="../../../../assets/image/merchants/{{
            tenant
          }}/oz-white-logo.svg"
          alt="logo"
        />
      </div>
    </ng-container>
  </div>
</div>
